module.exports = __webpack_public_path__ + "static/media/facebook2.89242f53.svg";